// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"359":"5a92ea4b","556":"0401e7fa","606":"e8a2f61d","635":"d0f42f4f","812":"ee8544e0"}[chunkId] + ".chunk.js";
};